import { useEffect, useRef } from 'react';

/**
 * Runs a callback exactly once on mount, guarded by a ref flag.
 * Used for one-time initialization that should NOT re-run even if
 * the parent re-renders (e.g., setting form defaults from fetched data).
 *
 * The callback is intentionally excluded from the effect deps — it captures
 * whatever closure state exists at mount time. The provided deps array controls
 * when the effect *could* run, but the ref guard ensures it only runs once.
 *
 * @param {Function} callback - Function to run once (captured at mount)
 * @param {Array} deps - Dependencies for the useEffect (callback is not included)
 */
const useInitGuard = (callback, deps) => {
    const hasRunRef = useRef(false);
    useEffect(() => {
        if (hasRunRef.current) return;
        hasRunRef.current = true;
        callback();
    }, deps); // eslint-disable-line react-hooks/exhaustive-deps -- callback intentionally excluded; guard ensures single execution
};

export default useInitGuard;
